// import dei microservizi
import general from '@/i18n/locales/it/general';
import forms from '@/i18n/locales/it/forms';
import table from '@/i18n/locales/it/table';
import headers from '@/i18n/locales/it/headers';

export default { 
    general,
    forms,
    table,
    headers
};